import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Modal, Button, Input } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseRadioList from '../../components/Elements/BaseRadios';
import { _newLine } from '../../utils/helpers';
import { createScheduleArea, updateScheduleArea } from '../../redux/actions/scheduleAreaActions';

class ScheduleAreaForm extends Component {
    state = { isLoading: false };

    submit = event => {
        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if (error) return;

            const request = this.props.currentItem
                ? this.props.updateScheduleArea(this.props.currentItem.id, values)
                : this.props.createScheduleArea(values);

            this.setState({ isLoading: true });
            request
                .then(() => {
                    this.props.reloadData();
                    this.close();
                })
                .catch(() => null)
                .finally(() => this.setState({ isLoading: false }));
        });
    };

    close = () => {
        this.props.form.resetFields();
        this.props.onCancel();
    };

    render() {
        const { visible, currentItem } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                visible={visible}
                title={currentItem ? 'Sửa khu vực làm việc' : 'Thêm khu vực làm việc'}
                onCancel={this.close}
                maskClosable={false}
                width={isMobile ? '100%' : '40%'}
                footer={[
                    <Button key="cancel" onClick={this.close}>Huỷ</Button>,
                    <Button key="submit" type="primary" loading={this.state.isLoading} onClick={this.submit}>
                        {currentItem ? 'Cập nhật' : 'Tạo'}
                    </Button>
                ]}
            >
                {visible ? (
                    <Form layout="vertical">
                        <Form.Item label="Tên khu vực">
                            {getFieldDecorator('name', {
                                rules: [
                                    { required: true, whitespace: true, message: 'Vui lòng nhập tên khu vực.' },
                                    { max: 255, message: 'Tên khu vực không vượt quá 255 ký tự.' }
                                ],
                                initialValue: currentItem?.name || ''
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note', {
                                initialValue: currentItem ? _newLine(currentItem.note) : ''
                            })(<Input.TextArea rows={3} />)}
                        </Form.Item>
                        <Form.Item label="Trạng thái">
                            {getFieldDecorator('status', {
                                rules: [{ required: true, message: 'Vui lòng chọn trạng thái.' }],
                                initialValue: currentItem ? Number(currentItem.status) : 1
                            })(
                                <BaseRadioList options={[
                                    { label: 'Kích hoạt', value: 1 },
                                    { label: 'Chưa kích hoạt', value: 0 }
                                ]} />
                            )}
                        </Form.Item>
                    </Form>
                ) : null}
            </Modal>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    createScheduleArea: data => dispatch(createScheduleArea(data)),
    updateScheduleArea: (id, data) => dispatch(updateScheduleArea(id, data))
});

export default connect(null, mapDispatchToProps)(Form.create({ name: 'ScheduleAreaForm' })(ScheduleAreaForm));
